module.exports = __webpack_public_path__ + "4dacaabdcb909c22a6938f8bf5fe300f.pdf";